import { createSlice } from '@reduxjs/toolkit';
import { globalApi } from '../services/globalApi';
import { regionApi } from '../services';
import { RootState } from './index';
import { MY_ACCOUNT_LIST } from '../utils/helper';

interface IGroup {
  global: Record<string, any>;
  regions: Record<string, any>;
  groups: Record<string, any>;
  currentGroup: Record<string, any>;
  haGroups: Record<string, any>;
  currentHaGroup: Record<string, any>;
  hasGroup: boolean;
}
const initialState: IGroup = {
  global: {},
  regions: {},
  groups: {
    // [MY_ACCOUNT_LIST]: {
    //   id: MY_ACCOUNT_LIST,
    //   name: 'My account list',
    //   desc: 'My account list'
    // }
  },
  currentGroup: {
    // id: MY_ACCOUNT_LIST,
    // name: 'My account list',
    // desc: 'My account list'
  },
  haGroups: {},
  currentHaGroup: {},
  hasGroup: false
};

const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    updateCurrentGroup: (state, { payload }) => {
      if (payload.id !== undefined) {
        state.currentGroup = payload;
      }
    },
    updateHaCurrentGroup: (state, { payload }) => {
      if (payload.id !== undefined) {
        state.currentHaGroup = payload;
      }
    },
    cleanGroupCache: (state, { payload }) => {
      const groupId = payload;
      if (groupId && Object.keys(state.groups).includes(groupId)) {
        const oData = state.groups[groupId];
        state.groups[groupId] = {
          id: oData.id,
          name: oData.name,
          region: oData.region,
          regionObj: oData.regionObj,
          desc: oData.desc
        };
      }
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      globalApi.endpoints.userLogin.matchFulfilled,
      (state, { payload }) => {
        state.global = payload;
        if (payload.group_region?.length) {
          const regions = payload.group_region;
          regions.forEach((obj) => {
            const alias = obj?.region_alias;
            if (alias) {
              state.regions[alias] = {
                ...obj,
                alias,
                id: obj?.region_id,
                name: obj?.region_alias,
                url: obj?.region_url,
                globalToken: payload.region_token,
                isHide: true
              };
              state.hasGroup = true;
            }
          });
        }
      }
    );
    builder.addMatcher(
      globalApi.endpoints.getRegions.matchFulfilled,
      (state, { payload }) => {
        payload.forEach((obj) => {
          const alias = obj?.alias;
          if (alias) {
            state.regions[alias] = {
              ...obj,
              globalToken: state.global.region_token,
              isHide: false
            };
          }
        });
      }
    );
    builder.addMatcher(
      regionApi.endpoints.regionLogin.matchFulfilled,
      (state, { payload }) => {
        const region: Record<string, any> = payload || {};
        // regions are keyed by alias; the region login response may use
        // `region` instead of `alias`, so fall back to it
        const alias = region?.alias || region?.region;
        if (alias && state.regions[alias]) {
          const mergedObj = {
            ...state.regions[alias],
            ...region
          };
          state.regions[alias] = mergedObj;
          const groups =
            region?.groups?.map((g: Record<string, any>) => ({
              ...g,
              region: g.id ? region?.region : undefined,
              regionObj: g.id ? mergedObj : undefined,
              desc:
                g.id === MY_ACCOUNT_LIST
                  ? g.name
                  : `${region?.region} | ${g.name}`
            })) || [];
          groups.flat(1).forEach((obj: Record<string, any>) => {
            if (obj?.id) {
              state.groups[obj?.id] = obj;
              state.haGroups[obj?.id] = obj;
            }
          });
        }
      }
    );
    builder.addMatcher(
      regionApi.endpoints.groupAccountsByPage.matchFulfilled,
      (state, { payload }) => {
        const group: Record<string, any> = payload || {};
        if (group?.group_id && state.groups[group.group_id]) {
          const accounts = group?.data?.results?.reduce(
            (
              accumulator: Record<string, any>,
              account: Record<string, any>
            ) => {
              return {
                ...accumulator,
                [account?.account_id]: {
                  ...account,
                  region: state.groups[group.group_id].regionObj,
                  group_id: group?.group_id,
                  page: group?.page,
                  pageSize: group?.pageSize
                }
              };
            },
            {}
          );
          const obj: Record<string, any> = {};
          obj.accounts = {
            ...accounts
          };
          obj.count = group?.data?.count;
          obj.next = group?.data?.next;
          obj.page = group?.page;
          obj.pageSize = group?.pageSize;
          state.groups[group?.group_id] = {
            ...(state.groups[group?.group_id] || {}),
            ...obj
          };
          state.haGroups[group?.group_id] = {
            ...(state.haGroups[group?.group_id] || {}),
            ...obj
          };
          // state.groups[group?.group_id].accounts = {
          //   ...accounts
          // };
          // state.groups[group?.group_id].count = group?.data?.count;
          // state.groups[group?.group_id].next = group?.data?.next;
          // state.groups[group?.group_id].page = group?.page;
          // state.groups[group?.group_id].pageSize = group?.pageSize;
        }
      }
    );
    builder.addMatcher(
      regionApi.endpoints.groupAccountsByPage.matchRejected,
      (state, { error, meta }) => {
        console.warn('----------- get group account list rejected', meta);
        const groupId = meta?.arg?.originalArgs?.groupId || '';
        if (groupId) {
          state.groups[groupId].accounts = {};
          state.haGroups[groupId].accounts = {};
        }
      }
    );
  }
});

const { reducer, actions } = groupSlice;

export const { updateHaCurrentGroup, updateCurrentGroup, cleanGroupCache } =
  actions;
// return all the regions not only group belonged region
export const selectGroupRegions = (state: RootState) => state.group.regions;
export const selectGroupGlobalRegions = (state: RootState) =>
  state.group.global.group_region || [];
export const selectGroups = (state: RootState) => state.group.groups;
export const selectHaGroups = (state: RootState) => state.group.haGroups;
export const selectCurrentGroup = (state: RootState) =>
  state.group.currentGroup;
export const selectHaCurrentGroup = (state: RootState) =>
  state.group.currentHaGroup;
export const selectHasGroup = (state: RootState) => state.group.hasGroup;

export default reducer;
